import {
  INSPECTION_APPLIES_TO_LABELS,
  INSPECTION_QUESTION_KIND_LABELS,
  INSPECTION_SCHEDULE_CADENCE_LABELS,
  INSPECTION_STATUS_LABELS,
  type InspectionAppliesTo,
  type InspectionQuestionKind,
  type InspectionScheduleCadence,
  type InspectionStatus,
  type InspectionTemplateStatus,
} from '@sitewise/shared';
import { Badge } from '@sitewise/ui';

const TEMPLATE_STATUS_LABEL: Record<InspectionTemplateStatus, string> = {
  draft: 'Draft',
  published: 'Published',
};

export function formatDate(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString();
}

export function formatDateTime(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString();
}

export function formatRelativeDays(iso: string | null): string {
  if (!iso) return '—';
  const ms = new Date(iso).getTime() - Date.now();
  const days = Math.round(ms / (24 * 60 * 60 * 1000));
  if (days === 0) return 'today';
  if (days === 1) return 'tomorrow';
  if (days === -1) return 'yesterday';
  if (days > 0) return `in ${days}d`;
  return `${Math.abs(days)}d ago`;
}

export function appliesToLabel(a: InspectionAppliesTo): string {
  return INSPECTION_APPLIES_TO_LABELS[a];
}

export function questionKindLabel(k: InspectionQuestionKind): string {
  return INSPECTION_QUESTION_KIND_LABELS[k];
}

export function cadenceLabel(c: InspectionScheduleCadence, customDays?: number | null): string {
  if (c === 'custom') {
    return customDays ? `Every ${customDays} days` : 'Custom';
  }
  return INSPECTION_SCHEDULE_CADENCE_LABELS[c];
}

export function StatusBadge({ status }: { status: InspectionStatus }) {
  const variant = {
    scheduled: 'default',
    in_progress: 'warning',
    submitted: 'success',
    cancelled: 'danger',
  } as const;
  return <Badge variant={variant[status]}>{INSPECTION_STATUS_LABELS[status]}</Badge>;
}

export function TemplateStatusBadge({ status }: { status: InspectionTemplateStatus }) {
  const variant = {
    draft: 'default',
    published: 'success',
  } as const;
  return <Badge variant={variant[status]}>{TEMPLATE_STATUS_LABEL[status]}</Badge>;
}
